import React from 'react';
import classes from './DateSearchV2.module.css';
import DatePicker from 'react-datepicker';
import calendarIcon from '../../../assets/icons/calendar-icon.svg';
import closeIcon from '../../../assets/icons/close.svg';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB, es, de, fr, nl } from 'date-fns/locale';

// setDefaultLocale('de');
// registerLocale('de', de);
const localeMap: Record<string, any> = {
  en: enGB,
  es: es,
  de: de,
  fr: fr,
  nl: nl,
};
type Props = {
  placeholder?: string;
  startDateLabel: string;
  endDateLabel: string;
  startDateValue: Date | undefined;
  endDateValue: Date | undefined;
  startDateOnChange: (date: Date | undefined) => void;
  endDateOnChange: (date: Date | undefined) => void;
  selectedColumn?: string;
  maxAppointmentDate?: Date;
};

const DateSearchV2: React.FC<Props> = ({
  startDateLabel,
  endDateLabel,
  placeholder,
  startDateValue,
  endDateValue,
  startDateOnChange,
  endDateOnChange,
  selectedColumn,
  maxAppointmentDate,
}) => {
  const maxDate = React.useMemo(() => {
    return selectedColumn === 'appointment_time' ? maxAppointmentDate : new Date();
  }, [selectedColumn, maxAppointmentDate]);
  const lang = localStorage.getItem('lang') || 'en';
  return (
    <div className={classes.mainContainer}>
      <div className={classes.startDateContainer}>
        <div className={classes.label}>{startDateLabel}</div>
        <DatePicker
          className={classes.datePicker}
          placeholderText={placeholder}
          selected={startDateValue}
          onChange={(date) => date && startDateOnChange(date)}
          dateFormat="dd.MM.yyyy"
          maxDate={new Date()}
          locale={localeMap[lang]}
                  />
        <div>
          {startDateValue ? (
            <img
              src={closeIcon}
              className={classes.closeIcon}
              alt="closeIcon"
              onClick={() => startDateOnChange(undefined)}
            />
          ) : (
            <img src={calendarIcon} className={classes.icon} alt="calendar" />
          )}
        </div>
      </div>
      <div className={classes.endDateContainer}>
        <div className={classes.label}>{endDateLabel}</div>
        <DatePicker
          className={classes.datePicker}
          placeholderText={placeholder}
          selected={endDateValue}
          onChange={(date) => date && endDateOnChange(date)}
          dateFormat="dd.MM.yyyy"
          maxDate={maxDate}
          minDate={startDateValue}
          locale={localeMap[lang]}
          />
        <div>
          {endDateValue ? (
            <img
              src={closeIcon}
              className={classes.closeIcon}
              alt="closeIcon"
              onClick={() => endDateOnChange(undefined)}
            />
          ) : (
            <img src={calendarIcon} className={classes.icon} alt="calendar" />
          )}
        </div>
      </div>
    </div>
  );
};

export { DateSearchV2 };
